import React, { useState, useEffect } from 'react'
import { SmallChevronUp, SmallChevronDown } from '../../../../../../images/common'

export const TextAreaInput = ({
  label = '',
  value = '',
  onChange = (val) => null,
  placeholder = '',
  id
}) => {

  const [inputValue, setInputValue] = useState(value)
  const [debouncedValue, setDebouncedValue] = useState(inputValue)

  useEffect(() => {
    if (value !== inputValue) {
      setInputValue(value)
    }
  }, [value])

  useEffect(() => {
    const debounceTimeout = setTimeout(() => {
      setDebouncedValue(inputValue)
    }, 300)

    return () => {
      clearTimeout(debounceTimeout)
    }
  }, [inputValue])

  useEffect(() => {
    if (value !== inputValue) {
      onChange(debouncedValue)
    }
  }, [debouncedValue])

  const handleInputChange = (value) => {
    setInputValue(event.target.value)
  }

  const handleBlur = () => {}

  return (
    <div className=''>
      {label &&
        <div className='chart-editor__label'>
          <label className='text-field__label1' htmlFor={id}>{label}</label>
        </div>
      }
      <div className='chart-editor-data-streams-input chart-editor-data-streams-input--textarea'>
        <textarea
          className='chart-editor-data-streams-input__textarea'
          placeholder={placeholder}
          value={inputValue}
          onChange={(e) => handleInputChange(e.target.value)}
          onBlur={handleBlur}
          onFocus={() => null}
          name={id}
          id={id}
        />
      </div>
    </div>
  )
}